// Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { AutoSizer, List } from 'react-virtualized';
import { sendBestFiveRequest } from '../../../apis/web_socket';
import { BzButton, BzInputText } from '../../../components';
import { toastConfig } from '../../../redux/actions/toast';
import { selectScripForDelete } from '../../../redux/actions/watchlist';
import { getMktSegIdFromMappedMktSegId, getScripDisplayDescription, returnCountWithPad } from '../../../utils/global_functions';
import { WATCHLIST_GRID_INDEX, GRID_VIEW } from '../../../utils/global_variables';
import PriceVolumeViewCard from './PriceVolumeViewCard';
import { SortableContainer } from 'react-sortable-hoc';
import ZeroStates from '../../ZeroStates';
import { scripAdditionalinfo } from '../../../apis/nontransactional';
import { getApiExchangeNameFromMktSegId } from '../../../utils/global_functions';
import { useUnload } from '../../../hooks';


const PriceVolumeView = SortableContainer(({ bIsShowDeleteCheckBox, arrcombinedData, setArrcombinedData, bIsShowSortHandle, strSearchScrip, setStrSearchScrip, arrRowData, setIsSideBar, setIsExpanded, arrWatchlistData, handleWatchlistViewChange, isPortFolio = false, isConstituent, ref, ...props }) => {
    const dispatch = useDispatch();
    const activeWatchList = useSelector(state => state?.watchList?.activeWatchList);

    // Hari k:24-07-2024: portfolio-holdings-price value view-start
    const [arrScrips, setArrScrips] = useState([]);

    useEffect(() => {
        if (isPortFolio) {
            setArrScrips(arrWatchlistData?.filter((each) => each !== undefined)); //K.Hari :05-02-2025 filtering undefined values 
        } else if (isConstituent) {
            setArrScrips(arrRowData);
        } else {
            setArrScrips(activeWatchList?.scrips);
        }
    }, [isPortFolio, isConstituent, arrWatchlistData, activeWatchList]);
    // Hari k:24-07-2024: portfolio-holdings-price value view-end 
    const handleAdditionalScrips = async () => {
        const arrPayload = arrScrips?.map((each) => ({
            exchange: getApiExchangeNameFromMktSegId(each[WATCHLIST_GRID_INDEX.SEGMENT_ID]),
            scrip_token: each[WATCHLIST_GRID_INDEX.TOKEN]
        }));
        const response = await scripAdditionalinfo(arrPayload);
        const objResp = response?.data?.result;
        const arrcombinedScrips = arrScrips?.map((scrip) => {
            const objMatchedScrip = objResp?.find((each) => getMktSegIdFromMappedMktSegId(each?.nMarketSegmentId) + '_' + each?.nToken === scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
            return { scripInfo: [...scrip], additionalInfo: objMatchedScrip };
        });
        setArrcombinedData(arrcombinedScrips);
    };

    useEffect(() => {
        if (arrScrips?.length && activeWatchList?.scrips?.length > 0) {
            handleAdditionalScrips();
        }
    }, [activeWatchList, arrScrips]);


    const arrSelecedScripForDelete = useSelector(state => state?.watchList?.arrSelecedScripForDelete);
    const handleSelectScripsForDelete = (data) => {
        if (arrSelecedScripForDelete?.some((each) => each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === data[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])) {
            const arrScrips = arrSelecedScripForDelete.filter((item) => item[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] !== data[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
            dispatch(selectScripForDelete(arrScrips));
            dispatch(toastConfig({ show: true, message: <div className='d-flex justify-content-start align-items-center'> Remove <div className='set-alert-remove-count font-regular mx-1'> {returnCountWithPad(arrScrips?.length)}</div> {arrScrips?.length === 1 ? 'scrip' : 'scrips'} from  '{activeWatchList?.sWatchListName}'</div>, button: [{ btnName: "Close", type: "CANCEL_REMOVING_SCRIPS", className: "btn btn-outline-active ms-3" }, { btnName: "Remove", type: "REMOVE_SCRIPS", className: "btn btn-outline-active ms-3" }] }));

        } else {
            const arrScrips = [...arrSelecedScripForDelete, data];
            dispatch(selectScripForDelete(arrScrips));
            dispatch(toastConfig({ show: true, message: <div className='d-flex justify-content-start align-items-center'> Remove <div className='set-alert-remove-count font-regular mx-1'> {returnCountWithPad(arrScrips?.length)}</div> {arrScrips?.length === 1 ? 'scrip' : 'scrips'} from  '{activeWatchList?.sWatchListName}'</div>, button: [{ btnName: "Close", type: "CANCEL_REMOVING_SCRIPS", className: "btn btn-outline-active ms-3" }, { btnName: "Remove", type: "REMOVE_SCRIPS", className: "btn btn-outline-active ms-3" }] }));

        }


    };
    // Vaibhav SIngh: 11-12-23:BT-109055L Search bug fix Upadted logic: Start 
    const arrPriceVolumeData = useMemo(() => {
        let keywords = strSearchScrip?.toLowerCase()?.split(' ');
        if (strSearchScrip?.length > 0) {
            return arrcombinedData?.filter((scrip) => {
                let rowData = `${scrip?.scripInfo[WATCHLIST_GRID_INDEX?.SYMBOL] + scrip?.scripInfo[WATCHLIST_GRID_INDEX?.EXCHANGE] + getScripDisplayDescription(scrip?.scripInfo) + scrip?.scripInfo[WATCHLIST_GRID_INDEX?.INSTRUMENT] + scrip?.scripInfo[WATCHLIST_GRID_INDEX?.OPTIONTYPE]}`;
                return keywords?.every(keyword => rowData?.toLowerCase()?.includes(keyword));
            });
        } else {
            return arrcombinedData;
        }
    }
        , [arrcombinedData, strSearchScrip]);



    const handleScripSearchChange = (e) => {
        setStrSearchScrip(e.target.value);
    };

    const [arrSubScrips, setArrSubScrips] = useState([]);
    // Vaibhav SIngh: 11-12-23:BT-109055L Search bug fix Updated logic :End
    const handleRowsRendered = ({ startIndex, stopIndex, }) => {
        const arrVisibleItems = arrPriceVolumeData?.length > 0 && arrPriceVolumeData?.slice(startIndex, stopIndex + 1);
        const arrNotVisibleItems = arrPriceVolumeData?.filter((item) => !arrVisibleItems?.includes(item));
        let newArrSubScrips = [];
        
        arrVisibleItems?.length > 0 && arrVisibleItems?.forEach((each) => {
            newArrSubScrips.push({ exchangeId: each?.scripInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: each?.scripInfo[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: false });
            sendBestFiveRequest({ exchangeId: each?.scripInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: each?.scripInfo[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true });
        });
        if (newArrSubScrips?.length > 0) {
            setArrSubScrips([...newArrSubScrips]);
        }
        arrNotVisibleItems?.length > 0 && arrNotVisibleItems?.forEach((each) => {
            sendBestFiveRequest({ exchangeId: each?.scripInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: each?.scripInfo[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: false });

        });
    };
    const handleSelectAllScrips = () => {
        if (arrSelecedScripForDelete?.length === activeWatchList['scrips']?.length) {
            dispatch(selectScripForDelete([]));
            dispatch(toastConfig({ show: true, message: <div className='d-flex justify-content-start align-items-center'> Remove <div className='set-alert-remove-count font-regular mx-1'> 0</div> scrip from  '{activeWatchList?.sWatchListName}'</div>, button: [{ btnName: "Close", type: "CANCEL_REMOVING_SCRIPS", className: "btn btn-outline-active ms-3" }, { btnName: "Remove", type: "REMOVE_SCRIPS", className: "btn btn-outline-active ms-3" }] }));


        } else {
            dispatch(selectScripForDelete(activeWatchList['scrips']));
            dispatch(toastConfig({ show: true, message: <div className='d-flex justify-content-start align-items-center'> Remove <div className='set-alert-remove-count font-regular mx-1'> {returnCountWithPad(activeWatchList['scrips'].length)}</div> {activeWatchList['scrips'].length === 1 ? 'scrip' : 'scrips'} from  '{activeWatchList?.sWatchListName}'</div>, button: [{ btnName: "Close", type: "CANCEL_REMOVING_SCRIPS", className: "btn btn-outline-active ms-3" }, { btnName: "Remove", type: "REMOVE_SCRIPS", className: "btn btn-outline-active ms-3" }] }));

        }
    };

    const handlePriceVolumeViewUnSubscription = useCallback(() => {
        if (arrSubScrips?.length > 0) {
            arrSubScrips?.forEach((eachScrip) => {
                sendBestFiveRequest(eachScrip);
            });
        }
    }, [arrSubScrips]);

    useUnload(() => {
        handlePriceVolumeViewUnSubscription();
    });

    const rowRenderer = ({ index, key, style }) => {

        return (
            <div key={key} style={style} id={arrRowData[index][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]}>
                <Container fluid className='p-0'>
                    <PriceVolumeViewCard setIsSideBar={setIsSideBar} setIsExpanded={setIsExpanded} arrRowData={arrRowData[index]} arrPriceVolumeViewCardData={arrPriceVolumeData[index]} key={arrPriceVolumeData[index]?.scripInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]} handleSelectScripsForDelete={handleSelectScripsForDelete} bIsShowDeleteCheckBox={bIsShowDeleteCheckBox} index={index} bIsShowSortHandle={bIsShowSortHandle} />
                </Container>
            </div>
        );
    };


    const getRowHeight = () => {
        if (window.matchMedia('screen and (max-width:1600px) and (min-width:1367px)').matches) {
            return 190;
        } else if (window.matchMedia('screen and (max-width:1366px) and (min-width:1281px)').matches) {
            return 185;
        } else if (window.matchMedia('screen and (max-width:1280px) and (min-width:1024px)').matches) {
            return 185;
        } else {
            return 190;
        }
    };



    return (
        <Container fluid className='p-0' >
            <Row className='d-flex align-item-center g-0 px-2 py-2 mb-1 bdr-btm' >
                <Col md={3} className='d-flex justify-content-start'>
                    <div className='position-relative w-100'>
                        <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                        <BzInputText autoFocus size='sm' placeholder='Search scrip' onChange={handleScripSearchChange} value={strSearchScrip} type="search" className='p-l-30 font-regular'></BzInputText>
                    </div>
                </Col>
                <Col md={9} className='d-flex justify-content-end align-items-center'>
                    <BzButton className='btn btn-sm btn-primary btn-rounded' onClick={handleWatchlistViewChange.bind(this, GRID_VIEW.DEFAULT_VIEW)}>Default View</BzButton>
                </Col>
            </Row>
            {/* Bhagyashri P [17-11-2023] : BT-109055 - Price Volume View classes - Starts */}
            {bIsShowDeleteCheckBox && <Row className='g-0 px-3 py-2 bdr-btm'>
                <Col md={12} className='d-flex justify-content-start align-items-center'>
                    <div className='form-check'>
                        <input type='checkbox' className='form-check-input me-2 mt-1' onChange={handleSelectAllScrips} checked={arrSelecedScripForDelete?.length === activeWatchList['scrips']?.length} id='selectAllScrips' />
                    </div>
                    <div htmlFor='selectAllScrips' className='font-regular font-size4 color-text'>Select All</div>
                </Col>

            </Row>}
            {/* Bhagyashri P [17-11-2023] : BT-109055 - Price Volume View classes - Starts */}

            {arrPriceVolumeData?.length > 0 ?
                <Row className='g-0' >
                    <Col className={isPortFolio ? 'portolio-price-volume-view-wrapper' : 'price-volume-view-wrapper'}>
                        <AutoSizer >
                            {
                                ({ width, height }) => {
                                    return (<List  width={1880} height={height} ref={ref} rowCount={arrPriceVolumeData?.length} rowHeight={getRowHeight} rowRenderer={rowRenderer} onRowsRendered={handleRowsRendered}></List>);
                                }
                            }
                        </AutoSizer>
                    </Col>
                </Row> :
                strSearchScrip?.length > 0 && arrPriceVolumeData?.length === 0 ?
                    <div className='zero-state-alerts zero-state-alerts-xl'>
                        <ZeroStates heading="No matches found" subText="Try adjusting your search to find what you are looking for" icon='icon-64 icon-nodata mb-3 mrgauto' />
                    </div>
                    : null}
        </Container>
    );
});

export default memo(PriceVolumeView);
// Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End